import { useEffect, useState } from "react";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { useChatStore } from "../../../store/ChatStore";
import { User } from "../../../../imsdk/db/t_user";
import * as ImSdk from "../../../../imsdk/api";
import { showToast } from "../../../components/Toast";
import { useIsFocused } from "@react-navigation/native";
import { postJson } from "../../../net/http";
import { Str_TransferFail, Str_TransferGroup, Str_TransferSuc } from "../../../language/string_res";
import { TopicUserListRender } from "../TopicUsers";

export const GroupTransferUser = ({ navigation, route }: MainNavProps<'GroupTransferUser'>) => {
    const [users, setUsers] = useState<User[]>([]);
    const { chatState } = useChatStore()
    const members = chatState.curTopicWithSummary.users ?? []
    const tid = chatState.curTopicWithSummary.topic.tid;
    const isFocused = useIsFocused()
    const im = ImSdk.getInstance();
    const currentAppkey = im.CurrentAppkey();
    const group = chatState.curTopicWithSummary.group

    useEffect(() => {
        if (isFocused) {
            initUserList()
        }
    }, [isFocused]);
    async function initUserList() {
        const useUsers = members.filter(
            (v) =>
                v.uid !== group?.uid &&
                v.appkey === currentAppkey // 只能转给自己同事
        );
        setUsers(useUsers as any as User[]);
    }
    function handleSubmit(user: User) {
        postJson("/v1/sdk/group/holder/change", {
            body: { tid: tid, toUid: user.uid }
        }).then((res) => {
            if (!res.code) {
                showToast(Str_TransferSuc);
                onClose()
            } else {
                showToast(res.msg || Str_TransferFail);
                onClose!();
            }
        });
    }
    const onClose = () => { navigation.goBack() }

    return (
        <TopicUserListRender
            title={Str_TransferGroup}
            users={users}
            onClose={onClose}
            onClick={handleSubmit}
        />

    );
};

